// Angular
import { Injectable } from '@angular/core';
// Translation
import { TranslateService } from '@ngx-translate/core';
import {Subject} from 'rxjs';

export interface Locale {
  lang: string;
  // tslint:disable-next-line:ban-types
  data: Object;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  // Private properties
  private langIds: any = [];
  currentLanguage = new Subject();

  /**
   * Service Constructor
   *
   * @param translate: TranslateService
   */
  constructor(private translate: TranslateService) {
    // add new langIds to the list
    this.translate.addLangs(['de']);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('de');
  }

  /**
   * Load Translation
   *
   * @param args: Locale[]
   */
  loadTranslations(...args: Locale[]): void {
    const locales = [...args];
    locales.forEach(locale => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);

      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
  }

  /**
   * Setup language
   *
   * @param lang: any
   */
  setLanguage(lang) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      this.currentLanguage.next(lang);
      localStorage.setItem('language', lang);
    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    this.currentLanguage.next(localStorage.getItem('language') || this.translate.getDefaultLang());
    return localStorage.getItem('language') || this.translate.getDefaultLang();
  }
}
